import { render, staticRenderFns } from "./emailCampaign.vue?vue&type=template&id=bc3f66c4"
import script from "./emailCampaign.vue?vue&type=script&lang=js"
export * from "./emailCampaign.vue?vue&type=script&lang=js"
import style0 from "./emailCampaign.vue?vue&type=style&index=0&id=bc3f66c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports